"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _requestError = _interopRequireDefault(require("@setapp/request-error"));

var _signupMetadata = _interopRequireDefault(require("@setapp/signup-metadata"));

var _humps = require("humps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Authenticator = /*#__PURE__*/function () {
  function Authenticator(options) {
    (0, _classCallCheck2.default)(this, Authenticator);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "metadata", void 0);
    (0, _defineProperty2.default)(this, "tokenManager", void 0);
    this.options = {
      apiRoot: options.apiRoot,
      cookiesDomain: options.cookiesDomain,
      tokenManager: options.tokenManager
    };
    this.metadata = new _signupMetadata.default({
      cookiesDomain: this.options.cookiesDomain
    });
  }

  (0, _createClass2.default)(Authenticator, [{
    key: "signUp",
    value: function signUp(data, options) {
      var _this = this;

      var metaData = this.metadata.getAll();

      var payload = _objectSpread(_objectSpread({}, metaData), data);

      return fetch("".concat(this.options.apiRoot, "/me"), {
        method: 'POST',
        body: JSON.stringify((0, _humps.decamelizeKeys)(payload)),
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          'Accept-Language': options.language
        }
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return Promise.reject(_requestError.default.create(response));
          }).then(function (errorJson) {
            return Promise.reject(_requestError.default.create(response, errorJson));
          });
        }

        return response.json();
      }).then(function (response) {
        return _this.onSignUpSuccess((0, _humps.camelizeKeys)(response.data));
      });
    }
  }, {
    key: "onSignUpSuccess",
    value: function onSignUpSuccess(response) {
      var accessToken = response.token,
          refreshToken = response.refreshToken;
      this.options.tokenManager.saveTokens({
        accessToken: accessToken,
        refreshToken: refreshToken
      });
      this.metadata.cleanAll();
      return response;
    }
  }]);
  return Authenticator;
}();

var _default = Authenticator;
exports.default = _default;
//# sourceMappingURL=authenticator.js.map